<h1>{{"navigation.orders" | translate}}</h1>

<div class="search-panel">
    <form [formGroup]="searchForm">
        <mat-form-field color="standart" [ngClass]="(!isEnglish()) ? 'input-form-field-de' : 'input-form-field-en'">
            <input matInput formControlName="deliveryNmr" (keydown.enter)="search($event)" [placeholder]="'home.orders.deliveryNmr' | translate">
        </mat-form-field>
        <mat-form-field color="standart" [ngClass]="(!isEnglish()) ? 'input-form-field-de' : 'input-form-field-en'">
            <input matInput formControlName="commission" (keydown.enter)="search($event)" [placeholder]="'home.orders.commission' | translate">
        </mat-form-field>
        <mat-form-field color="standart" [ngClass]="(!isEnglish()) ? 'input-form-field-de' : 'input-form-field-en'">
            <input formControlName="chargeNum" matInput (keydown.enter)="search($event)" [placeholder]="'home.orders.chargeNum' | translate">
        </mat-form-field>
        <mat-form-field color="standart" class="datepicker-form-field">
            <mat-label>{{"home.orders.dateFrom" | translate}}</mat-label>
            <input  matInput [matDatepicker]="df" (keydown.enter)="search($event)" formControlName="dateFrom">
            <mat-datepicker-toggle matSuffix [for]="df"></mat-datepicker-toggle>
            <mat-datepicker #df></mat-datepicker>
        </mat-form-field>
        <mat-form-field color="standart" class="datepicker-form-field">
            <mat-label>{{"home.orders.dateTo" | translate}}</mat-label>
            <input matInput [matDatepicker]="dt" (keydown.enter)="search($event)" formControlName="dateTo">
            <mat-datepicker-toggle matSuffix [for]="dt"></mat-datepicker-toggle>
            <mat-datepicker #dt></mat-datepicker>
        </mat-form-field>
        <button mat-flat-button color="primary" class="action-button" (click)="pickLastNMonths(2)">{{'home.orders.last2Months' | translate}}</button>
        <button mat-flat-button color="primary" class="action-button" (click)="pickLastNMonths(3)">{{'home.orders.last3Months' | translate}}</button>
        <app-search-button (click)="search($event)"></app-search-button>
    </form>
</div>

<div class="order-table" style="margin-bottom: 20px;">
    <table mat-table [dataSource]="items" matSort class="table-overview">

        <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef>{{"home.orders.actions" | translate}}</th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (change)="select(row)" class="checkbox" [checked]="isNeedCheck(row)">
              </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="orderDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"home.orders.orderDate" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{getOrderDate(row.orderDate)}}</td>
        </ng-container>

        <ng-container matColumnDef="side">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"home.orders.side" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{getSide(row)}}</td>
        </ng-container>

        <ng-container matColumnDef="article">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"home.orders.article" | translate}}</th>
            <td mat-cell *matCellDef="let row"><span style="white-space: pre-line">{{getArticle(row)}}</span></td>
        </ng-container>

        <ng-container matColumnDef="commission">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"home.orders.commission" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.commission}}</td>
        </ng-container>

        <ng-container matColumnDef="chargeNum">
            <th mat-header-cell *matHeaderCellDef>{{"home.orders.chargeNum" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.chargeNumber}}</td>
        </ng-container>

        <ng-container matColumnDef="return">
            <th mat-header-cell *matHeaderCellDef class="return-header">{{"home.orders.return" | translate}}</th>
            <td mat-cell *matCellDef="let row">
                <div *ngIf="row.isReturn === true">
                    <img src="assets/img/icons/revert.svg" [matTooltip]="'home.orders.tooltips.withReturn' | translate" matTooltipPosition="above">
                </div>
                <div *ngIf="row.isReturn === false" >
                    <img src="assets/img/icons/revert-cross.svg" [matTooltip]="'home.orders.tooltips.withoutReturn' | translate" matTooltipPosition="above">
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-header">{{"newOrder.equipment.columnNames.info" | translate}}</th>
            <td mat-cell *matCellDef="let row" class="actions">
                <div class="d-flex">
                    <img src="assets/img/icons/info.svg" style="cursor: pointer;" (click)="openInfoDialog(row)" matTooltipPosition="above">
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-card *ngIf="isLoading" class="spinner-wrapper">
        <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
    </mat-card>

    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons [hidePageSize]="true" color="standart" class="paginator-overview" #overviewPaginator="matPaginator"></mat-paginator>
</div>

<button mat-flat-button color="primary" style="width: 10%; margin-left: 869px;" (click)="cancel()">{{'common.buttons.cancel' | translate}}</button>
<button mat-flat-button color="primary" [disabled]="(selectedRows.length === 0) ? 'disabled' : null" style="width: 10%; margin-left: 20px;" (click)="copy()">{{'common.buttons.next' | translate}}</button>